import "react";
const useDevelopmentEffect = (effect, deps)=>{};
export { useDevelopmentEffect };
